import { exitsConfig } from '@/lib/analytics/kpis/instagram/stories/exits';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const exitsMVConfig = {
    ...exitsConfig,
    id: 'exits',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
